import { ReactNode } from 'react';

export function UnderlinedText({ children }: { children: ReactNode }) {
  return (
    <span className="before:bg-orange relative inline-block leading-[1.1] before:absolute before:inset-x-[0.05em] before:bottom-[0.06em] before:-z-10 before:h-[0.12em] before:rounded-full">
      {children}
    </span>
  );
}
